export const USER_PERMISSIONS = {
  PROFILE: {
    VIEW: 'profile.view',
    EDIT_OWN: 'profile.edit_own',
    VIEW_STUDENTS: 'profile.view_students',
  },

  POSTS: {
    VIEW: 'posts.view',
    CREATE: 'posts.create',
    EDIT_OWN: 'posts.edit_own',
    DELETE_OWN: 'posts.delete_own',
    DELETE_ANY: 'posts.delete_any',
  },

  MESSAGING: {
    VIEW: 'messaging.view',
    EDIT: 'messaging.edit',
    SEND: 'messaging.send',
    MESSAGE_STUDENTS: 'messaging.message_students',
    MESSAGE_STAFF: 'messaging.message_staff',
    MESSAGE_GROUPS: 'messaging.message_groups',
    DELETE_OWN: 'messaging.delete_own',
    ATTACH_FILES: 'messaging.attach_files',
    EXPORT_TRANSCRIPT: 'messaging.export_transcript',
  },

  GROUPS: {
    VIEW: 'groups.view',
    CREATE: 'groups.create',
    EDIT: 'groups.edit',
    DELETE: 'groups.delete',
    ADD_MEMBERS: 'groups.add_members',
    REMOVE_MEMBERS: 'groups.remove_members',
    MANAGE_MEMBERSHIP: 'groups.manage_membership',
  },

  ASSIGNMENTS: {
    VIEW_ROSTER: 'assignments.view_roster',
    VIEW_CONNECTIONS: 'assignments.view_connections',
    MANAGE: 'assignments.manage',
    BULK_UPLOAD: 'assignments.bulk_upload',
  },

  CALENDAR: {
    VIEW: 'calendar.view',
    CREATE: 'calendar.create',
    EDIT_OWN: 'calendar.edit_own',
    DELETE_OWN: 'calendar.delete_own',
    CREATE_SHARED: 'calendar.create_shared',
  },

  STUDENTS: {
    VIEW_ASSIGNED: 'students.view_assigned',
    VIEW_NETWORK: 'students.view_network',
    MANAGE_CONNECTIONS: 'students.manage_connections',
  },

  CAREER: {
    VIEW: 'career.view',
    CREATE: 'career.create',
    EDIT: 'career.edit',
    DELETE: 'career.delete',
    PUBLISH: 'career.publish',
  },

  MODERATION: {
    VIEW_REPORTED: 'moderation.view_reported',
    REVIEW_REPORTS: 'moderation.review_reports',
    REMOVE_CONTENT: 'moderation.remove_content',
    RESTORE_CONTENT: 'moderation.restore_content',
    MANAGE_TERMS: 'moderation.manage_terms',
  },

  MEETINGS: {
    VIEW: 'meetings.view',
    REQUEST: 'meetings.request',
    REQUEST_CHANGES: 'meetings.request_changes',
    APPROVE: 'meetings.approve',
    DENY: 'meetings.deny',
    CANCEL: 'meetings.cancel',
  },

  USERS: {
    VIEW: 'users.view',
    INVITE: 'users.invite',
    EDIT: 'users.edit',
    DEACTIVATE: 'users.deactivate',
    ASSIGN_ROLES: 'users.assign_roles',
    REMOVE_ROLES: 'users.remove_roles',
    VEIW_SCHOOL: 'users.view_school',
  },

  ROLES: {
    VIEW: 'roles.view',
    CREATE: 'roles.create',
    EDIT: 'roles.edit',
    DELETE: 'roles.delete',
    MANAGE_PERMISSIONS: 'roles.manage_permissions',
  },

  ORG: {
    VIEW_SCHOOLS: 'org.view_schools',
    VIEW_DISTRICTS: 'org.view_districts',
    MANAGE_ONEROSTER: 'org.manage_oneroster',
  },

  REPORTS: {
    VIEW: 'reports.view',
    CREATE: 'reports.create',
    MANAGE_STATUS: 'reports.manage_status',
    ASSIGN: 'reports.assign',
  },

  AUDIT: {
    VIEW_LOGS: 'audit.view_logs',
    CREATE_REPORTS: 'audit.create_reports',
  },

  ANALYTICS: {
    VIEW: 'analytics.view',
  },
};
